import React from 'react';
import { useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';

/**
 * Barra superior verde alinhada a myTeamPerformance / módulo Performance.
 * @param {string} title - Nome da página (ex.: Gestão de Pesquisas)
 */
export default function SurveyPageHeader({ title }) {
    const { pathname } = useLocation();
    const isModuleHome = pathname === '/survey/' || pathname === '/survey';
    const backHref = isModuleHome ? '/painel/' : '/survey/';

    return (
        <div className="row flex-nowrap">
            <div className="col text-bg-green p-3 d-flex align-items-center flex-wrap gap-2">
                <div className="d-flex align-items-center flex-wrap">
                    <a href={backHref} className="fs-6 fw-bold ps-5 text-decoration-none text-white">
                        <FontAwesomeIcon icon={solid('arrow-left')} className="me-2" />
                        Pesquisas
                    </a>
                    {title ? (
                        <span className="fs-6 fw-bold text-white ms-3 border-start border-white border-opacity-50 ps-3">
                            {title}
                        </span>
                    ) : null}
                </div>
            </div>
        </div>
    );
}
